import { render } from "./SidebarMenuButtonChild.vue?vue&type=template&id=1cc32dd8&ts=true"
import script from "./SidebarMenuButtonChild.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarMenuButtonChild.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/sidebar/SidebarMenuButtonChild.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1cc32dd8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1cc32dd8', __exports__)) {
    api.reload('1cc32dd8', __exports__)
  }
  
  module.hot.accept("./SidebarMenuButtonChild.vue?vue&type=template&id=1cc32dd8&ts=true", () => {
    api.rerender('1cc32dd8', render)
  })

}


export default __exports__